import { useState } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import calendar from 'src/static/vectors/calendar_blue.svg';
import { Job } from 'src/types';
import CareersForm from '../CareersForm/CareersForm';
import './JobCard.css';

const JobCard = ({ job }: { job: Job }) => {
	const [apply, setApply] = useState(false);
	const { id, contractType, postedDate, benefits, hiringProcess, title, requirements, location, mission } = job;

	return (
		<article id={`job-card-${id}`} className="careers-card job-card">
			<h1>{title}</h1>
			<header>
				{postedDate && (
					<section id="posted-date">
						<img src={calendar} alt="calendar symbol" />
						<span>
							<FormattedDate value={postedDate} month="short" day="numeric" year="numeric" />
						</span>
					</section>
				)}
				<section id="tags-section">
					<span>{contractType}</span>
					<span>{location}</span>
				</section>
			</header>
			<section id="job-card-your-mission">
				<details open>
					<summary role="heading" aria-level={2}>
						<h2>
							<span>
								<FormattedMessage id="job-card.your-mission" />
							</span>
						</h2>
					</summary>
					<p>{mission}</p>
				</details>
			</section>
			<section id="job-card-requirements">
				<details>
					<summary role="heading" aria-level={2}>
						<h2>
							<FormattedMessage id="job-card.requirements" />
						</h2>
					</summary>
					<ul>
						{requirements.map((r: string, i: number) => (
							<li key={i}>{r}</li>
						))}
					</ul>
				</details>
			</section>
			<section id="job-card-benefits">
				<details>
					<summary role="heading" aria-level={2}>
						<h2>
							<FormattedMessage id="job-card.benefits" />
						</h2>
					</summary>
					<ul>
						{benefits.map((b: string, i: number) => (
							<li key={i}>{b}</li>
						))}
					</ul>
				</details>
			</section>
			<section id="job-card-hiring-process">
				<details>
					<summary role="heading" aria-level={2}>
						<h2>
							<FormattedMessage id="job-card.hiring-process" />
						</h2>
					</summary>
					<ul>
						{hiringProcess.map((step: string, i: number) => (
							<li key={i}>{step}</li>
						))}
					</ul>
				</details>
			</section>
			<section id="job-card-careers-form">
				{!apply ? (
					<button className="apply-button" onClick={() => setApply(!apply)}>
						<FormattedMessage id="apply" />
					</button>
				) : (
					<CareersForm jobId={id} />
				)}
			</section>
		</article>
	);
};

export default JobCard;
